import { NgOptimizedImage } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  input,
  viewChild,
} from '@angular/core';
import { GrooveDialogDirective } from '@groove/angular';

@Component({
  selector: 'app-lightbox-image',
  imports: [NgOptimizedImage, GrooveDialogDirective],
  templateUrl: './lightbox-image.component.html',
  styleUrl: './lightbox-image.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LightboxImageComponent {
  src = input.required<string>();
  alt = input.required<string>();
  caption = input<string>('');
  aspectRatio = input.required<string>();
  sizes = input('100vw');
  // Mark the thumbnail NgOptimizedImage `priority` (preload + fetchpriority=high,
  // no lazy) when this instance is the page's LCP element — e.g. the first
  // above-the-fold notation on /bass-lessons/play-along-tracks. Default false:
  // gallery/below-the-fold lightboxes stay lazy.
  priority = input(false);
  // How the thumbnail fills its aspect-ratio box. Default 'fill' matches the
  // browser default (no visual change for callers whose box ratio equals the
  // image's intrinsic ratio). Pass 'cover' to crop-to-fill when forcing a
  // uniform tile shape that differs from the photo's natural ratio.
  fit = input<'fill' | 'cover' | 'contain'>('fill');

  private dialog = viewChild.required<{ nativeElement: HTMLDialogElement }>(
    'dialog',
  );

  open(): void {
    this.dialog().nativeElement.showModal();
  }

  close(): void {
    this.dialog().nativeElement.close();
  }
}
